import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { subscribeToNewsletter } from '../../utils/API'
class Footer extends Component {


    constructor(props) {
        super(props);
        this.state = { email: '' };
        this.handleChangeFormElement = this.handleChangeFormElement.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChangeFormElement(evt) {
        const value = evt.target.value;
        if (evt.target.name === 'agreePolicy' || evt.target.name === 'noNewsLetter') {
            const { checked } = evt.target
            this.setState({ [evt.target.name]: checked });
        } else {
            this.setState({ [evt.target.name]: value });
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        subscribeToNewsletter(this.state)
    }


    render() {
        return (
            <footer className="py-11 position-relative" data-bg-img="assets/images/bg/03.png" style={{ backgroundColor: 'var(--primary-color)' }}>
                <div className="shape-1" style={{ height: '150px', overflow: 'hidden' }}>
                    <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '100%', width: '100%' }}>
                        <path d="M0.00,49.98 C150.00,150.00 271.49,-50.00 500.00,49.98 L500.00,0.00 L0.00,0.00 Z" style={{ stroke: 'none', fill: '#fff' }} />
                    </svg>
                </div>
                <Container className=" mt-11">
                    <Row className="text-white text-center mt-8">
                        <Col>
                            <hr className="mb-8" />Copyright © Falendi | All Rights Reserved</Col>
                    </Row>
                </Container>
            </footer>
        );
    }
}

export default Footer;